import React, { useState, useEffect } from "react";
import "./Home.css";
import { Container, Box, Grid, Button } from "@mui/material";
import logo from '../../../../image/logomin.png'
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import logoImg from "../../../../image/lexpedia-logo.jpg";

const Home = () => {
  const navigate =useNavigate()

  return (
    <div className="admin__home">
      <Container fixed>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid
              className="wecolme_screen"
              item
              xs={12}
              sx={{
                justifyContent: "center",
                alignContent: "center",
                textAlign: "center",
              }}
            >
              <img src={logoImg} alt="logo" />
            </Grid>
            {/* <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                alignContent: "center",
                textAlign: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  swal({
                    title: "Are you sure?",
                    text: "Are You Want To logOut",
                    icon: "warning",
                    buttons: true,
                  }).then((willDelete) => {
                    if (willDelete) {
                      localStorage.setItem("token", "");
                      navigate("/");
                    } else {
                    }
                  });
                }}
              >
                Log Out
              </Button>
            </Grid> */}
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default Home;
